import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetRiskFactorStatus = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.fundraising.risk_factor_status],
    queryFn: () =>
      fundraisingService.riskFactorStatus().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
